import { render, staticRenderFns } from "./facebookLogin.vue?vue&type=template&id=5555588a&scoped=true&"
import script from "./facebookLogin.vue?vue&type=script&lang=js&"
export * from "./facebookLogin.vue?vue&type=script&lang=js&"
import style0 from "./facebookLogin.vue?vue&type=style&index=0&id=5555588a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5555588a",
  null
  
)

export default component.exports